import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { EASE } from "@/components/motion";

export default function PaymentCancel() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center py-20 px-6" data-testid="payment-cancel-page">
      <motion.div
        initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: EASE }}
        className="w-full max-w-lg bg-[#101218] border border-white/10 rounded-2xl p-10 md:p-14 text-center shadow-[0_30px_80px_rgba(0,0,0,0.5)]"
      >
        <h1 className="font-serif text-3xl text-white mb-4">No charge was made.</h1>
        <p className="text-slate-400 text-sm leading-relaxed mb-8">
          You cancelled before paying. Your plans are still here whenever you're ready, or book a free
          call first if you'd rather talk it through.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/pricing" data-testid="cancel-back-pricing"
            className="bg-gold text-obsidian hover:bg-gold-light font-mono text-xs uppercase tracking-[0.15em] px-8 py-4 rounded-xl transition-all shadow-[0_0_20px_rgba(93,123,255,0.35)]">
            Back to Pricing
          </Link>
          <Link to="/contact" data-testid="cancel-book-call"
            className="bg-white/5 border border-white/15 text-white hover:bg-white/10 font-mono text-xs uppercase tracking-[0.15em] px-8 py-4 rounded-xl transition-all flex items-center justify-center gap-2">
            <ArrowLeft className="w-4 h-4" /> Book a Free Call
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
